<section class="py-5" style="background: linear-gradient(135deg, #f3f7fa 0%, #e9ecef 100%);">
    <div class="container">
        <div class="row justify-content-center mb-5">
            <div class="col-lg-8 text-center">
                <div class="mb-2 text-muted" style="font-size:1.2rem;">
                    Mehr Daten. Mehr Relevanz. Mehr Erfolg.
                </div>
                <p class="lead mt-3 mb-0">
                    Unsere Plattform schließt diese Lücke mit einem modernen Ansatz:<br>
                    Sie erstellen Ihre Firmenlisten selbst – individuell, zielgenau, deutschlandweit oder regional.
                </p>
            </div>
        </div>
        <div class="row g-4">
            <!-- Feature Card 1 -->
            <div class="col-md-4">
                <div class="card h-100 border-0 shadow feature-card position-relative rounded-4 transition">
                  <span class="badge bg-primary position-absolute top-0 start-50 translate-middle mt-n3 px-4 py-2 fs-6 rounded-pill shadow-sm" style="z-index:2;">
                    <i class="fa fa-sliders-h me-1"></i> Konfigurator
                  </span>
                    <div class="card-body pt-5">
                        <div class="icon-circle mb-3 mx-auto">
                            <i class="fa fa-cogs fa-2x text-primary"></i>
                        </div>
                        <h5 class="fw-semibold mb-2 text-center">Listen-Konfigurator</h5>
                        <ul class="list-unstyled small mb-0">
                            <li class="mb-2"><i class="fa fa-filter text-secondary me-2"></i>Gezielt filtern nach Branche, Region, Keywords & mehr</li>
                            <li><i class="fa fa-check-circle text-secondary me-2"></i>Listen passend zu Ihrem Geschäft</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Feature Card 2 -->
            <div class="col-md-4">
                <div class="card h-100 border-0 shadow feature-card position-relative rounded-4 transition">
                  <span class="badge bg-info text-dark position-absolute top-0 start-50 translate-middle mt-n3 px-4 py-2 fs-6 rounded-pill shadow-sm" style="z-index:2;">
                    <i class="fa fa-layer-group me-1"></i> Mehr Daten
                  </span>
                    <div class="card-body pt-5">
                        <div class="icon-circle mb-3 mx-auto bg-info-subtle">
                            <i class="fa fa-database fa-2x text-info"></i>
                        </div>
                        <h5 class="fw-semibold mb-2 text-center">Erweiterte Datenvielfalt</h5>
                        <ul class="list-unstyled small mb-0">
                            <li class="mb-2"><i class="fa fa-envelope text-secondary me-2"></i>E-Mail, Website, Adresse, Google-Bewertung</li>
                            <li class="mb-2"><i class="fa fa-share-alt text-secondary me-2"></i>Social-Media-Links, Impressum, Job-Portale</li>
                            <li><i class="fa fa-key text-secondary me-2"></i>Branchenspezifische Schlüsselwörter</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Feature Card 3 -->
            <div class="col-md-4">
                <div class="card h-100 border-0 shadow feature-card position-relative rounded-4 transition">
                  <span class="badge bg-success position-absolute top-0 start-50 translate-middle mt-n3 px-4 py-2 fs-6 rounded-pill shadow-sm" style="z-index:2;">
                    <i class="fa fa-sync-alt me-1"></i> Immer aktuell
                  </span>
                    <div class="card-body pt-5">
                        <div class="icon-circle mb-3 mx-auto bg-success-subtle">
                            <i class="fa fa-refresh fa-2x text-success"></i>
                        </div>
                        <h5 class="fw-semibold mb-2 text-center">Immer aktuell</h5>
                        <ul class="list-unstyled small mb-0">
                            <li class="mb-2"><i class="fa fa-database text-secondary me-2"></i>Laufend gepflegte und erweiterte Datenbank</li>
                            <li><i class="fa fa-check text-secondary me-2"></i>Nur aktuelle, relevante Informationen</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>